var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('iframe',{staticStyle:{"border":"none","overflow":"hidden"},attrs:{"src":"/rakuten-ad.html","width":"468","height":"160","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }